module.exports = __webpack_public_path__ + "static/img/bzbx.439b429e.png";